import { createFileRoute } from "@tanstack/react-router";
import MigrainesPage from "@/pages/MigrainesPage";
import { buildConditionSchema } from "@/components/ConditionPageLayout";
export const Route = createFileRoute("/migraines-treatment-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Migraines Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Migraine treatment in Coral Springs, FL. Ketamine therapy and supportive care for chronic migraines at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:title",
          content: "Migraines Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Migraine treatment in Coral Springs, FL. Ketamine therapy and supportive care for chronic migraines at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/migraines-treatment-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/migraines-treatment-coral-springs-fl",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildConditionSchema({
              seoTitle:
                "Ketamine for Migraines Treatment Coral Springs, FL | Neuro Wellness TMS Centers of America",
              seoDescription:
                "Break free from severe, refractory chronic migraines with IV Ketamine infusion therapy at Neuro Wellness TMS Centers in Coral Springs, FL.",
              canonical: "/migraines-treatment-coral-springs-fl",
              breadcrumbs: [
                { name: "Services", href: "/services-directory" },
                {
                  name: "Conditions Treated",
                  href: "/ketamine-treatment-coral-springs-fl",
                },
                {
                  name: "Migraines",
                  href: "/migraines-treatment-coral-springs-fl",
                },
              ],
            }),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MigrainesPage />;
}
